module.exports = __webpack_public_path__ + "static/index/files/consent.pdf";